export default "__VITE_ASSET__$HRTaXpr__"